import { render, staticRenderFns } from "./Priced.vue?vue&type=template&id=2c814b0c&scoped=true"
import script from "./Priced.vue?vue&type=script&lang=js"
export * from "./Priced.vue?vue&type=script&lang=js"
import style0 from "./Priced.vue?vue&type=style&index=0&id=2c814b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c814b0c",
  null
  
)

export default component.exports